import { CountUp } from 'countup.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const runCounter = (el) => {
  const useGrouping = el.dataset.useGrouping
  const decimalPlaces = el.dataset.decimalPlaces
  const end = el.dataset.end

  const opts = {
    useGrouping: !!+useGrouping,
  }

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces
  }

  const counter = new CountUp(el, end, opts)

  counter.start()
}

document.querySelectorAll('.element-stats.as-content').forEach((el) => {
  const trigger = el.querySelector('.element-container')

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: trigger,
      pin: true,
      markers: false,
      scrub: 1,
      start: () => {
        const siteHeaderHeight = document.querySelector('.site-header').offsetHeight

        return `top ${siteHeaderHeight}`
      },
      end: () => `+=${trigger.offsetHeight * 2}`,
      onLeave: function (self) {
        let start = self.start
        self.scroll(self.start)
        self.disable(false, true)
        ScrollTrigger.refresh()
        window.scrollTo(0, start)
      },
    },
  })

  el.querySelectorAll('.stats-block').forEach((block) => {
    const value = block.querySelector('.stats-value')
    const title = block.querySelector('.stats-title')

    gsap.set(block, { opacity: 0, y: '10%' })
    gsap.set(value, { opacity: 0, y: '20%' })
    gsap.set(title, { opacity: 0, y: '20%' })

    timeline.to(block, { opacity: 1, y: 0, ease: 'power4', duration: 0.5 })

    timeline.to(
      value,
      {
        y: 0,
        opacity: 1,
        onStart: () => {
          runCounter(value.querySelector('[data-counter]'))
        },
      },
      '<25%'
    )

    timeline.to(
      title,
      {
        y: 0,
        opacity: 1,
      },
      '<75%'
    )
  })

  window._scrollTimelines.push(timeline)
})

const chunk = (inputArray) => {
  const perChunk = 2

  return inputArray.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / perChunk)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])
}

document.querySelectorAll('.element-stats.as-large').forEach((el) => {
  const trigger = el.querySelector('.element-container')
  const blocks = el.querySelectorAll('.stats-block')
  const multipleBlocks = blocks.length > 2

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: trigger,
      pin: true,
      markers: false,
      scrub: 1,
      start: () => {
        const siteHeaderHeight = document.querySelector('.site-header').offsetHeight

        return `top ${siteHeaderHeight}`
      },
      end: () => `+=${trigger.offsetHeight * 2}`,
      onLeave: function (self) {
        if (!multipleBlocks) {
          let start = self.start
          self.scroll(self.start)
          self.disable(false, true)
          ScrollTrigger.refresh()
          window.scrollTo(0, start)
        }
      },
    },
  })

  if (multipleBlocks) {
    const chunkedBlocks = chunk(Array.from(blocks))

    chunkedBlocks.forEach((chunks) => {
      chunks.forEach((block) => {
        const value = block.querySelector('.stats-value')
        const title = block.querySelector('.stats-title')
        const content = block.querySelector('.stats-content')

        gsap.set(block, { opacity: 0, y: '10%' })
        gsap.set(value, { opacity: 0, y: '20%' })
        gsap.set(title, { opacity: 0, y: '20%' })
        gsap.set(content, { opacity: 0, y: '20%' })

        timeline.to(block, { opacity: 1, y: 0, ease: 'power4', duration: 0.5 })

        timeline.to(
          value,
          {
            y: 0,
            opacity: 1,
            onStart: () => {
              runCounter(value.querySelector('[data-counter]'))
            },
          },
          '<25%'
        )

        timeline.to(
          title,
          {
            y: 0,
            opacity: 1,
          },
          '<75%'
        )

        timeline.to(
          content,
          {
            y: 0,
            opacity: 1,
          },
          '<75%'
        )
      })

      chunks.forEach((block) => {
        timeline.to(block, { opacity: 0, y: '-10%', ease: 'power4', duration: 0.5 })
      })
    })
  } else {
    blocks.forEach((block) => {
      const value = block.querySelector('.stats-value')
      const title = block.querySelector('.stats-title')
      const content = block.querySelector('.stats-content')

      gsap.set(block, { opacity: 0, marginTop: '10%' })
      gsap.set(value, { opacity: 0, y: '20%' })
      gsap.set(title, { opacity: 0, y: '20%' })
      gsap.set(content, { opacity: 0, y: '20%' })

      timeline.to(block, { opacity: 1, marginTop: 0, ease: 'power4', duration: 0.5 })

      timeline.to(
        value,
        {
          y: 0,
          opacity: 1,
          onStart: () => {
            runCounter(value.querySelector('[data-counter]'))
          },
        },
        '<25%'
      )

      timeline.to(
        title,
        {
          y: 0,
          opacity: 1,
        },
        '<75%'
      )

      timeline.to(
        content,
        {
          y: 0,
          opacity: 1,
        },
        '<75%'
      )
    })
  }

  window._scrollTimelines.push(timeline)
})
